import { createContext, useContext } from 'react';

import defaultConfig from './defaultConfig';

type Config = typeof defaultConfig;
type RequiredConfig = Pick<Config, 'graphqlURL' | 'cookie'>;

type ConfigContextType = Partial<Config> & RequiredConfig;

const ConfigContext = createContext<ConfigContextType>(defaultConfig);

function ConfigProvider({
  appConfig,
  children,
}: {
  appConfig: ConfigContextType;
  children: React.ReactNode;
}) {
  return <ConfigContext.Provider value={appConfig}>{children}</ConfigContext.Provider>;
}

function useConfig(): ConfigContextType {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within ConfigContext');
  }
  return context;
}

export type { Config, ConfigContextType };
export { ConfigProvider, useConfig, defaultConfig };
